import {RxStompConfig} from '@stomp/rx-stomp';
import {WebsocketService} from "./websocketService";
import {HttpClient} from "@angular/common/http";
import {environment} from '@environments/environment';
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";

export function WebsocketServiceFactory(http: HttpClient,toastrService:ToastrService,translateService:TranslateService) {
	//Construction du service
	return new WebsocketService(http,toastrService,translateService);
}

/**
 * Configuration de la connexion Websocket.
 */
export const stompConfig: RxStompConfig & CustomConfig = {
	//URL
	brokerURL: `${environment.baseUrl}/websocket`,

	// How often to heartbeat?
	// Interval in milliseconds, set to 0 to disable
	heartbeatIncoming: 0, // Typical value 0 - disabled
	heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

	// Wait in milliseconds before attempting auto reconnect
	// Set to 0 to disable
	// Typical value 500 (500 milli seconds)
	reconnectDelay: 5000,

	// Will log diagnostics on console
	// It can be quite verbose, not recommended in production
	// Skip this key to stop logging to console
	// debug: (msg: string): void => {
	// 	console.log(new Date(),msg);
	// },

	// 12 tentatives toutes les 5 secondes (voir le paramètre reconnectDelay ci-dessus), soit un délai max de 1 minute.
	reconnectMax: 12,
};

/**
 * Paramètre de configuration supplémentaire (custom)
 */
export type CustomConfig = {
	/** Nombre de tentatives de reconnexion */
	reconnectMax: number;
}
